import { useTheme } from '@emotion/react';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { menusSlice } from './_menus.slice';
import { DashboardMenuItem } from './DashboardMenuItem';
import { GenericMenuItemsWrapper } from './GenericMenuItems';
import { DividerStyled } from './GenericMenuItems/GenericMenuItems.styles';
import { MarketMenuItem } from './MarketMenuItem/MarketMenuItem';
import {
  DrawerHeaderStyled,
  DrawerStyled,
  IconButtonStyled,
  IconExpandedStyled,
  IconStyled,
  ListContainerStyled,
  MenuContainerStyled,
} from './Menu.styles';
import { isMenuOpened } from './menus.selectors';
import { TradingMenuItem } from './TradingMenuItem';
import { WalletMenuItem } from './WalletMenuItem';

export const Menu = () => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [elementsHeight, setElementsHeight] = useState({
    appIconSection: 0,
    expandButtonSection: 0,
    bottomButtonsSection: 0,
  });

  const isOpen = useSelector(isMenuOpened);

  const appIconSectionRef = useRef(null);
  const expandButtonSectionRef = useRef(null);

  const handleToggleOpenMenu = () =>
    dispatch(menusSlice.actions.toggleOpenMenu());

  const handleElementHeight = (elements) => {
    setElementsHeight((prevElHeight) => {
      const updatedElHeight = elements.reduce((acc, element) => {
        acc[element.elName] = element.elHeight;

        return acc;
      }, prevElHeight);

      return updatedElHeight;
    });
  };

  useLayoutEffect(() => {
    handleElementHeight([
      {
        elName: 'appIconSection',
        elHeight: appIconSectionRef.current.offsetHeight,
      },
      {
        elName: 'expandButtonSection',
        elHeight: expandButtonSectionRef.current.offsetHeight,
      },
    ]);
  }, []);

  return (
    <MenuContainerStyled>
      <DrawerStyled variant="permanent" open={isOpen}>
        <DrawerHeaderStyled ref={appIconSectionRef} open={isOpen}>
          {!isOpen ? (
            <IconStyled
              iconI={theme.customLogo.slogo}
              onClick={handleToggleOpenMenu}
            />
          ) : (
            <IconExpandedStyled
              iconI={theme.customLogo.logo}
              onClick={handleToggleOpenMenu}
            />
          )}
        </DrawerHeaderStyled>
        <Box ref={expandButtonSectionRef}>
          <IconButtonStyled onClick={handleToggleOpenMenu}>
            {isOpen ? (
              <FontAwesomeIcon icon={faAngleLeft} />
            ) : (
              <FontAwesomeIcon icon={faAngleRight} />
            )}
          </IconButtonStyled>
          <DividerStyled />
        </Box>
        <ListContainerStyled
          listHeight={
            elementsHeight.appIconSection -
            elementsHeight.expandButtonSection -
            elementsHeight.bottomButtonsSection
          }
        >
          <DashboardMenuItem />
          <MarketMenuItem />
          <WalletMenuItem />
          <TradingMenuItem />
        </ListContainerStyled>
        <GenericMenuItemsWrapper setElMenuHeight={handleElementHeight} />
      </DrawerStyled>
    </MenuContainerStyled>
  );
};

Menu.propTypes = {
  isOpen: PropTypes.bool,
  toggleOpenMenu: PropTypes.func.isRequired,
};
